import MediaApi from 'api-client/Media.api'

const MediaService = {
  getMediaItems(establishmentId) {
    return MediaApi.getMediaItems(establishmentId)
  },
  uploadMediaItem(mediaType, file, establishmentId, targetDealerId = null) {
    return MediaApi.uploadMediaItem(mediaType, file, establishmentId, targetDealerId)
  },
  getMediaHistory(mediaType, establishmentId, targetDealerId = null) {
    return MediaApi.getMediaHistory(mediaType, establishmentId, targetDealerId)
  },
  restoreMediaVersion(mediaType, versionId, establishmentId, targetDealerId = null) {
    return MediaApi.restoreMediaVersion(mediaType, versionId, establishmentId, targetDealerId)
  },
  previewMediaItem(mediaType, file) {
    return MediaApi.previewMediaItem(mediaType, file)
  },
}

export default MediaService
